module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/COMPUTER SCIENCE-SOFTWARE ENGINEERING-ca88c8efe684d9419beccdc449591187.png";